import React from 'react';
import EditRule from './EditRule';
import CreateNewRule from './CreateNewRule';
import PropTypes from 'prop-types';

const ConsentRule = ({ id }) => {
     return (
          <div className='rule-detail'>{id ? <EditRule id={id} /> : <CreateNewRule />}</div>
     );
};


ConsentRule.propTypes = {
     id: PropTypes.string,
};

export default ConsentRule;
